"use client";

import Link from "next/link";
import { motion, useReducedMotion } from "framer-motion";

export default function SectionCTA({ title, buttonText, href = "/book" }: { title: string; buttonText: string; href?: string }) {
  const shouldReduceMotion = useReducedMotion();

  return (
    <section className="fluid-section">
      <motion.div
        className="max-w-xl"
        initial={shouldReduceMotion ? {} : { opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.4 }}
      >
        <h2 className="fluid-h2 font-heading font-bold mb-4">{title}</h2>
        <p className="text-[13px] text-muted-foreground mb-8">30-minute call. No pitch. Just listening.</p>
        <Link href={href} className="btn-gold px-7 py-3.5">
          {buttonText}
        </Link>
      </motion.div>
    </section>
  );
}
